// TODO - remove lint disable when editing this file
/* eslint-disable */
import * as React from 'react'

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component'
export default (EmbeddedComponent, props) =>
  class extends React.PureComponent {
    static displayName = `Decorated(${getDisplayName(EmbeddedComponent)})`
    render() {
      return <EmbeddedComponent {...this.props} {...props} />
    }
  }
